import { PermissionBaseName } from './permissions'

const certificatePermissionPart = 'CERTIFICATE'
type CertPermission = Extract<
  PermissionBaseName,
  `${string}${typeof certificatePermissionPart}${string}`
>

// Of any level
function isCertificatePermission(
  permission: PermissionBaseName,
): permission is CertPermission {
  return permission.includes(certificatePermissionPart)
}

export function checkIsDirectCertificatePermission(
  permission: PermissionBaseName,
): permission is CertPermission {
  const notDirectEndings = ['_GENERIC', '_RVDD']
  const isDirectPermission = notDirectEndings.every(
    (ending) => !permission.endsWith(ending),
  )

  return isCertificatePermission(permission) && isDirectPermission
}
